import React from "react"

const Diamond = ({ width="72", height="62", viewBox="0 0 72 62" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#a-diamond-icon)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 25.685 24.895 16h22.21L56 25.685 36 46 16 25.685Zm15.92 7.381c.139.29.445.462.767.462a.884.884 0 0 0 .34-.068c.423-.175.613-.634.425-1.026l-3.3-6.878h11.32l-3.302 6.878c-.188.392.003.851.426 1.026.11.046.226.068.34.068a.846.846 0 0 0 .767-.462l3.605-7.51h4.449c.463 0 .838-.349.838-.778 0-.43-.375-.778-.838-.778H43.11l-2.02-3.541c-.215-.38-.723-.526-1.133-.324-.41.2-.567.672-.35 1.05L41.213 24H30.41l1.605-2.815c.217-.378.06-.85-.349-1.05-.41-.202-.918-.056-1.133.324L28.513 24h-3.674c-.464 0-.839.348-.839.778 0 .43.375.778.839.778h3.476l3.604 7.51Z"
          fill="#DB1616"
        />
      </g>
      <defs>
        <filter
          id="a-diamond-icon"
          x="-4"
          y="-10"
          width="80"
          height="80"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix values="0 0 0 0 0.558333 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

export default Diamond
